import Lead from 'app/models/lead';
import LeadGatherModal from 'app/views/modals/lead_gather_modal';

import Base from 'app/views/base';
import tmpl from 'templates/empty';

export default Base.extend({
  compiledTemplate: tmpl,

  events: {
    click: 'buttonClicked',
  },

  initialize({ source, user }) {
    this.model = new Lead({});
    this.source = source;
    this.user = user;
  },

  buttonClicked(e) {
    e.preventDefault();
    this.leadGatherModal = new LeadGatherModal({
      source: this.source,
      email: this.user.get('email'),
    }).show();
  },
});



// WEBPACK FOOTER //
// ./app/views/lead_gather_button_component.js